export const DEFAULT_COORDS = [45.034, 38.97]
export const DEFAULT_ZOOM = 13

export const DELAY = 10000

export const GPS_URL = 'https://m.marsruty.ru/krasnodar/gps.txt'
